<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
    <button (click)="onCloseClick.emit()" aria-label="Close" class="close" type="button">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
